export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("vincCalculating.title")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.potDiameter")]: {
          field: "requestPotDiameter",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.potHeight")]: {
          field: "requestPotHeight",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.frontGlassHeight")]: {
          field: "requestFrontGlassHeight",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.sideGlassHeight")]: {
          field: "requestSideGlassHeight",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.metalWidth")]: {
          field: "requestMetalWidth",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.outdoorTemperature")]: {
          field: "requestOutdoorTemperature",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.cabinTemperature")]: {
          field: "requestCabinTemperature",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.wallThickness")]: {
          field: "requestWallThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.insulationThickness")]: {
          field: "requestInsulationThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.cabinHeight")]: {
          field: "requestCabinHeight",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.totalGlasses")]: {
          field: "totalGlasses",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.totalWalls")]: {
          field: "totalWalls",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("vincCalculating.cabinTotalThermalLoad")]: {
          field: "cabinTotalThermalLoad",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("common.isActive")]: {
          field: "isActive",
          callback: (value) => {
            return value ? this.$t("common.active") : this.$t("common.passive");
          },
        },
        [this.$t("common.userInfo")]: {
          field: "user.fullname",
          callback: (value) => {
            return value;
          },
        },
      };
    },
  },
};
